import { httpRequest } from "../../http";

export class CommandGetEngagementStatus {
    async run(engagementId: number): Promise<string> {
        // This is a placeholder endpoint.
        const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/engagements/${engagementId}/status/`
        try {
            const response = await httpRequest<any>(url, { method: "GET" });
            return response.status ?? "";
        } catch (error) {
            console.error('Error fetching engagement status:', error);
            throw error;
        }
    }
}
